"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
exports.config = {
    cartUrl: 'https://cart-checkout.test-secureserver.net'
};
//# sourceMappingURL=test.js.map